<div class="dashboard-container">
  <!-- Summary Cards -->
  <div class="summary-cards">

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="summary-icon contact-icon">
          <mat-icon>people</mat-icon>
        </div>
        <div class="summary-details">
          <h3>Contacts</h3>
          <div class="summary-value">{{summaryData.totalContacts}}</div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/contacts">VIEW CONTACTS</a>
      </mat-card-actions>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/contacts/add">
          <mat-icon>person_add</mat-icon> Add Contact
        </a>
      </mat-card-actions>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="summary-icon bank-icon">
          <mat-icon>account_balance</mat-icon>
        </div>
        <div class="summary-details">
          <h3>Banks</h3>
          <div class="summary-value">{{summaryData.totalBanks}}</div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/banks">VIEW BANKS</a>
      </mat-card-actions> 
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/banks/add">
          <mat-icon>account_balance_wallet</mat-icon> Add Bank
        </a>
      </mat-card-actions>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="summary-icon loan-icon">
          <mat-icon>trending_up</mat-icon>
        </div>
        <div class="summary-details">
          <h3>Loans</h3>
          <div class="summary-value">{{summaryData.totalLoans}}</div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/loans">VIEW LOANS</a>
      </mat-card-actions>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/loans/add">
          <mat-icon>request_quote</mat-icon> Add Loan
        </a>
      </mat-card-actions>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="summary-icon insurance-icon">
          <mat-icon>health_and_safety</mat-icon>
        </div>
        <div class="summary-details">
          <h3>Insurance</h3>
          <div class="summary-value">{{summaryData.totalInsurance}}</div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/insurance">VIEW INSURANCE</a>
      </mat-card-actions>
      <mat-card-actions>
        <a mat-raised-button color="primary" routerLink="/insurance/add">
          <mat-icon>add_business</mat-icon> Add Insurance
        </a>
      </mat-card-actions>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="summary-icon debt-icon">
          <mat-icon>payments</mat-icon>
        </div>
        <div class="summary-details">
          <h3>Debts</h3>
          <div class="summary-value">Coming Soon</div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button disabled class="disabled-button">VIEW DEBTS</button>
      </mat-card-actions>
      <mat-card-actions>
        <button mat-raised-button disabled class="disabled-button">
          <mat-icon>money_off</mat-icon> Add Debt
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <!-- Insurance Policy Summaries Section -->
  <div class="section-header">
    <h2>Insurance Policy Summaries</h2>
  </div>

  <!-- No insurance policies message -->
  @if (insuranceSummaries.length === 0) {
    <div class="no-data">
      <p>No insurance policies found. Add insurance policies to see summaries here.</p>
    </div>
  }

  <!-- Insurance summaries by insured name -->
  <div class="insurance-summaries">
    <mat-card *ngFor="let summary of insuranceSummaries" class="insurance-summary-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>person</mat-icon>
        <mat-card-title>{{summary.insuredName}}</mat-card-title>
        <mat-card-subtitle>{{summary.policies}} {{summary.policies === 1 ? 'Policy' : 'Policies'}}</mat-card-subtitle>
      </mat-card-header>
      
      <mat-card-content>
        <div class="policy-summary-grid">
          <!-- Column 1: Insurance Amount -->
          <div class="policy-summary-column">
            <div class="column-header">Insurance Amount</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value">{{summary.totalInsurance | currency:'USD':true:'1.2-2'}}</div>
            </div>
          </div>
          
          <!-- Column 2: Premium -->
          <div class="policy-summary-column">
            <div class="column-header">Premium</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value">{{summary.totalPremium | currency:'USD':true:'1.2-2'}}</div>
            </div>
          </div>
          
          <!-- Column 3: Cash Value -->
          <div class="policy-summary-column">
            <div class="column-header">Cash Value</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value">{{summary.totalCashValue | currency:'USD':true:'1.2-2'}}</div>
            </div>
          </div>
          
          <!-- Column 4: Outstanding Loans -->
          <div class="policy-summary-column">
            <div class="column-header">Outstanding Loans</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value" [ngClass]="{'loan-amount': summary.totalLoanAmount > 0}">
                {{summary.totalLoanAmount | currency:'USD':true:'1.2-2'}}
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
      
      <mat-card-actions>
        <a mat-button color="primary" routerLink="/insurance">VIEW DETAILS</a>
      </mat-card-actions>
    </mat-card>
  </div>

  <!-- Loan Summaries Section -->
  <div class="section-header">
    <h2>Loan Summaries</h2>
  </div>

  <!-- No loans message -->
  @if (loanSummaries.length === 0) {
    <div class="no-data">
      <p>No active loans found. Add loans to see summaries here.</p>
    </div>
  }

  <!-- Loan summaries by contact name -->
  <div class="loan-summaries">
    <mat-card *ngFor="let summary of loanSummaries" class="loan-summary-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>account_circle</mat-icon>
        <mat-card-title>{{summary.contactName}}</mat-card-title>
        <mat-card-subtitle>{{summary.loans}} {{summary.loans === 1 ? 'Loan' : 'Loans'}}</mat-card-subtitle>
      </mat-card-header>
      
      <mat-card-content>
        <div class="policy-summary-grid">
          <!-- Column 1: Loan Amount -->
          <div class="policy-summary-column">
            <div class="column-header">Loan Amount</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value">{{summary.totalAmount | currency:'USD':true:'1.2-2'}}</div>
            </div>
          </div>
          
          <!-- Column 2: Remaining Balance -->
          <div class="policy-summary-column">
            <div class="column-header">Remaining Balance</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value" [ngClass]="{'loan-amount': summary.totalRemainingBalance > 0}">
                {{summary.totalRemainingBalance | currency:'USD':true:'1.2-2'}}
              </div>
            </div>
          </div>
          
          <!-- Column 3: Monthly Payment -->
          <div class="policy-summary-column">
            <div class="column-header">Monthly Payment</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value">{{summary.totalPayment | currency:'USD':true:'1.2-2'}}</div>
            </div>
          </div>
          
          <!-- Column 4: Average Interest Rate -->
          <div class="policy-summary-column">
            <div class="column-header">Volume Rate of Return</div>
            <div class="policy-summary-row total">
              <div class="policy-summary-value">{{summary.volumeRateOfReturn | percent:'1.2-2'}}</div>
            </div>
          </div>
        </div>
      </mat-card-content>
      
      <mat-card-actions>
        <a mat-button color="primary" routerLink="/loans">VIEW DETAILS</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
